function enhanceOpenStreetMapEmbeds() {
  const maps = Array.from(document.querySelectorAll(".acfstreetmap iframe"));

  maps.forEach((iframe, index) => {
    if (iframe.dataset.osmEnhanced === "true") {
      return;
    }

    iframe.dataset.osmEnhanced = "true";
    iframe.setAttribute("loading", iframe.getAttribute("loading") || "lazy");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute(
      "referrerpolicy",
      iframe.getAttribute("referrerpolicy") || "no-referrer-when-downgrade"
    );

    if (!iframe.getAttribute("title")) {
      iframe.setAttribute("title", "OpenStreetMap Lagekarte");
    }

    const wrapper = document.createElement("div");
    wrapper.className = "osm-embed";
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);

    const interactionButton = document.createElement("button");
    interactionButton.className = "osm-embed__interaction";
    interactionButton.type = "button";
    interactionButton.textContent = "Karte aktivieren";
    interactionButton.setAttribute("aria-describedby", `osm-embed-hint-${index}`);

    const hint = document.createElement("span");
    hint.className = "osm-embed__hint";
    hint.id = `osm-embed-hint-${index}`;
    hint.textContent = "Danach kann die Karte verschoben und gezoomt werden.";
    interactionButton.appendChild(hint);

    const fullscreenButton = document.createElement("button");
    fullscreenButton.className = "osm-embed__fullscreen";
    fullscreenButton.type = "button";
    fullscreenButton.title = "Vollbildmodus starten";
    fullscreenButton.setAttribute("aria-label", "Vollbildmodus starten");
    fullscreenButton.innerHTML =
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M5 10V5h5v2H8.41l3.3 3.29-1.42 1.42L7 8.41V10H5Zm9-5h5v5h-2V8.41l-3.29 3.3-1.42-1.42L15.59 7H14V5ZM7 15.59l3.29-3.3 1.42 1.42L8.41 17H10v2H5v-5h2v1.59ZM17 15.59V14h2v5h-5v-2h1.59l-3.3-3.29 1.42-1.42 3.29 3.3Z"/></svg>';

    wrapper.appendChild(interactionButton);
    wrapper.appendChild(fullscreenButton);

    const setActive = (active) => {
      wrapper.classList.toggle("is-active", active);
      iframe.style.pointerEvents = active ? "auto" : "none";
      interactionButton.hidden = active;
    };

    setActive(false);

    interactionButton.addEventListener("click", () => {
      setActive(true);
      iframe.focus();
    });

    wrapper.addEventListener("mouseleave", () => {
      setActive(false);
    });

    wrapper.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        setActive(false);
        interactionButton.focus();
      }
    });

    fullscreenButton.addEventListener("click", async () => {
      if (document.fullscreenElement === wrapper) {
        await document.exitFullscreen();
        return;
      }

      if (wrapper.requestFullscreen) {
        await wrapper.requestFullscreen();
      }
    });

    document.addEventListener("fullscreenchange", () => {
      const isFullscreen = document.fullscreenElement === wrapper;
      fullscreenButton.title = isFullscreen
        ? "Vollbildmodus beenden"
        : "Vollbildmodus starten";
      fullscreenButton.setAttribute(
        "aria-label",
        isFullscreen ? "Vollbildmodus beenden" : "Vollbildmodus starten"
      );
    });
  });
}

function observeOpenStreetMapEmbeds() {
  enhanceOpenStreetMapEmbeds();

  if (!document.body || typeof MutationObserver === "undefined") {
    return;
  }

  const observer = new MutationObserver(() => {
    enhanceOpenStreetMapEmbeds();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", observeOpenStreetMapEmbeds);
